/* Genusshandwerk – Kursprogramm als PDF (wird im Browser erzeugt, immer aktuell) */
(function () {
  if (window.ghKursprogramm) return;
  window.ghKursprogramm = true;

  var GOLD = [198, 161, 83], GOLD_DUNKEL = [150, 118, 52], DUNKEL = [20, 20, 20], TEXT = [40, 40, 40], GRAU = [110, 110, 110], LINIE = [222, 216, 204];
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function zwei(n) { return (n < 10 ? '0' : '') + n; }
  function sauber(s) {
    if (!s) return '';
    var d = document.createElement('textarea');
    d.innerHTML = String(s).replace(/<[^>]*>/g, '');
    return d.value.replace(/\s+/g, ' ').replace(/[​-‍﻿]/g, '').trim();
  }
  function ladeSkript(src) {
    return new Promise(function (ok, fehler) {
      if (window.jspdf && window.jspdf.jsPDF) return ok();
      var s = document.createElement('script');
      s.src = src; s.onload = function () { ok(); }; s.onerror = fehler;
      document.head.appendChild(s);
    });
  }
  function ladeBild(url, png) {
    return new Promise(function (ok) {
      if (!url) return ok(null);
      if (url.indexOf('//') === 0) url = 'https:' + url;
      var img = new Image(), fertig = false;
      var ende = function (wert) { if (!fertig) { fertig = true; ok(wert); } };
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = img.naturalWidth; c.height = img.naturalHeight;
          var ctx = c.getContext('2d');
          if (!png) { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); }
          ctx.drawImage(img, 0, 0);
          ende({ data: png ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.85), w: c.width, h: c.height, typ: png ? 'PNG' : 'JPEG' });
        } catch (e) { ende(null); }
      };
      img.onerror = function () { ende(null); };
      setTimeout(function () { ende(null); }, 6000);
      img.src = url;
    });
  }

  function erstelle(daten, bilder, logo) {
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
    var B = 210, H = 297, R = 16, innen = B - 2 * R;
    var jetzt = new Date();
    var stand = zwei(jetzt.getDate()) + '.' + zwei(jetzt.getMonth() + 1) + '.' + jetzt.getFullYear();
    var kurse = daten.kurse || [];
    var jahre = [];
    kurse.forEach(function (k) { var j = k.datum.slice(0, 4); if (jahre.indexOf(j) < 0) jahre.push(j); });
    var jahrText = jahre.length > 1 ? jahre[0] + '/' + jahre[jahre.length - 1].slice(2) : (jahre[0] || String(jetzt.getFullYear()));
    var shop = (daten.shop || '').replace(/\/$/, '');
    var shopKurz = shop.replace(/^https?:\/\//, '');

    doc.setProperties({ title: 'Kursprogramm ' + jahrText + ' – Genusshandwerk Andreas Vick', author: 'Genusshandwerk Andreas Vick', subject: 'Outdoor-Grill- und Kochkurse auf der Starkenburg Heppenheim' });

    /* Kopf */
    var kopfH = 58;
    doc.setFillColor.apply(doc, DUNKEL); doc.rect(0, 0, B, kopfH, 'F');
    doc.setFillColor.apply(doc, GOLD); doc.rect(0, kopfH, B, 0.8, 'F');
    doc.setFont('times', 'bold'); doc.setFontSize(10.5); doc.setTextColor.apply(doc, GOLD);
    doc.text('G E N U S S H A N D W E R K', R, 15);
    doc.setFont('times', 'bold'); doc.setFontSize(30); doc.setTextColor(255, 255, 255);
    doc.text('Kursprogramm', R, 30);
    var kw = doc.getTextWidth('Kursprogramm ');
    doc.setTextColor.apply(doc, GOLD); doc.text(jahrText, R + kw, 30);
    doc.setFont('times', 'italic'); doc.setFontSize(15); doc.setTextColor.apply(doc, GOLD);
    doc.text(daten.slogan || 'Feuer, Fleisch und Flaschenbier.', R, 39);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(10); doc.setTextColor(235, 235, 235);
    doc.text('Outdoor-Grill- & Kochkurse mit Metzgermeister Andreas Vick', R, 47);
    doc.setFontSize(8.5); doc.setTextColor(170, 170, 170);
    doc.text('Burgschänke Starkenburg · Starkenburgweg 51 · 64646 Heppenheim', R, 52.5);

    /* Logo rechts im Kopf – auf hellem Siegel, damit es auf Schwarz wirkt */
    var lr = 21, lx = B - R - lr, ly = kopfH / 2;
    doc.setFillColor(255, 255, 255); doc.circle(lx, ly, lr, 'F');
    doc.setDrawColor.apply(doc, GOLD); doc.setLineWidth(0.8); doc.circle(lx, ly, lr - 1.2, 'S');
    if (logo) {
      var lm = (lr - 3) * 2 * 0.86, lf = Math.min(lm / logo.w, lm / logo.h);
      doc.addImage(logo.data, logo.typ, lx - logo.w * lf / 2, ly - logo.h * lf / 2, logo.w * lf, logo.h * lf, undefined, 'FAST');
    } else {
      doc.setFont('times', 'bold'); doc.setFontSize(22); doc.setTextColor.apply(doc, DUNKEL);
      doc.text('AV', lx, ly + 3, { align: 'center' });
    }
    doc.link(lx - lr, ly - lr, lr * 2, lr * 2, { url: shop });

    /* Infozeilen */
    var y = kopfH + 9;
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.setTextColor.apply(doc, GOLD_DUNKEL);
    doc.text('JEDER KURS', R, y);
    doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, TEXT);
    doc.text('ca. 3,5 Stunden · Menü & Getränke inklusive · ab 16 Jahren · gegrillt wird bei jedem Wetter', R + 24, y);
    doc.setTextColor.apply(doc, GRAU);
    doc.text('Stand: ' + stand, B - R, y, { align: 'right' });
    y += 5;
    var g = daten.gutschein;
    doc.setFont('helvetica', 'bold'); doc.setTextColor.apply(doc, GOLD_DUNKEL);
    doc.text('VERSCHENKEN', R, y);
    doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, TEXT);
    doc.text('Geschenkgutschein' + (g && g.ab ? ' ab ' + sauber(g.ab) : '') + ' online · Firmen- & Gruppenevents auf Anfrage', R + 24, y);
    if (g && g.url) doc.link(R, y - 3.5, 140, 5, { url: g.url });
    y += 6;

    var fussHoehe = 26, unten = H - fussHoehe - 1;

    function folgeKopf() {
      doc.setFont('times', 'bold'); doc.setFontSize(9); doc.setTextColor.apply(doc, GOLD_DUNKEL);
      doc.text('G E N U S S H A N D W E R K', R, 14);
      doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, GRAU);
      doc.text('Kursprogramm ' + jahrText + ' · Stand: ' + stand, B - R, 14, { align: 'right' });
      doc.setDrawColor.apply(doc, LINIE); doc.setLineWidth(0.3); doc.line(R, 17, B - R, 17);
      return 24;
    }

    if (!kurse.length) {
      doc.setFont('times', 'italic'); doc.setFontSize(13); doc.setTextColor.apply(doc, TEXT);
      doc.text('Neue Termine sind in Planung – schau bald wieder vorbei: ' + shopKurz, R, y + 10);
      y += 20;
    }

    var bildB = 22, bildH = 27.5, xDatum = R + bildB + 6, xText = xDatum + 29, xPreis = B - R, textB = xPreis - 26 - xText;

    kurse.forEach(function (k, i) {
      var d = new Date(k.datum);
      var name = sauber(k.name), unter = sauber(k.unter), text = sauber(k.text), preis = sauber(k.preis);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.6);
      var zeilen = doc.splitTextToSize(text, textB);
      if (zeilen.length > 4) { zeilen = zeilen.slice(0, 4); zeilen[3] = zeilen[3].replace(/\s*\S*$/, '') + ' …'; }
      doc.setFont('times', 'bold'); doc.setFontSize(14);
      var nameZeilen = doc.splitTextToSize(name, textB);
      var hoehe = Math.max(bildH, 6 + nameZeilen.length * 5.6 + (unter ? 5 : 0) + zeilen.length * 3.75) + 4;

      if (y + hoehe > unten) { doc.addPage(); y = folgeKopf(); }
      var y0 = y + 2;

      /* Bild – nie beschnitten, mittig in 4:5-Feld */
      var b = bilder[i];
      if (b) {
        var f = Math.min(bildB / b.w, bildH / b.h), w = b.w * f, h = b.h * f;
        doc.setFillColor(245, 242, 236); doc.rect(R, y0, bildB, bildH, 'F');
        doc.addImage(b.data, 'JPEG', R + (bildB - w) / 2, y0 + (bildH - h) / 2, w, h, undefined, 'FAST');
      } else {
        doc.setFillColor.apply(doc, DUNKEL); doc.rect(R, y0, bildB, bildH, 'F');
        doc.setFont('times', 'bold'); doc.setFontSize(16); doc.setTextColor.apply(doc, GOLD);
        doc.text('GH', R + bildB / 2, y0 + bildH / 2 + 2, { align: 'center' });
      }

      /* Datum */
      doc.setFont('times', 'bold'); doc.setFontSize(30); doc.setTextColor.apply(doc, GOLD_DUNKEL);
      doc.text(zwei(d.getDate()), xDatum, y0 + 10.5);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor.apply(doc, DUNKEL);
      doc.text(MONATE[d.getMonth()].toUpperCase() + ' ' + d.getFullYear(), xDatum, y0 + 16);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAU);
      doc.text(TAGE[d.getDay()], xDatum, y0 + 20.5);
      doc.text(d.getHours() + ':' + zwei(d.getMinutes()) + ' Uhr', xDatum, y0 + 24.5);

      /* Titel + Text */
      var ty = y0 + 4.5;
      doc.setFont('times', 'bold'); doc.setFontSize(14); doc.setTextColor.apply(doc, DUNKEL);
      doc.text(nameZeilen, xText, ty); ty += nameZeilen.length * 5.6;
      if (unter) {
        doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor.apply(doc, GOLD_DUNKEL);
        doc.text(doc.splitTextToSize(unter.toUpperCase(), textB)[0], xText, ty - 0.6); ty += 5;
      }
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.6); doc.setTextColor.apply(doc, TEXT);
      doc.text(zeilen, xText, ty, { lineHeightFactor: 1.3 });

      /* Preis */
      doc.setFont('times', 'bold'); doc.setFontSize(16); doc.setTextColor.apply(doc, DUNKEL);
      doc.text(preis, xPreis, y0 + 9, { align: 'right' });
      doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor.apply(doc, GRAU);
      doc.text('pro Person', xPreis, y0 + 13.5, { align: 'right' });
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
      if (k.aus) { doc.setTextColor.apply(doc, GRAU); doc.text('AUSGEBUCHT', xPreis, y0 + 21, { align: 'right' }); }
      else { doc.setTextColor.apply(doc, GOLD_DUNKEL); doc.text('Online buchen >', xPreis, y0 + 21, { align: 'right' }); }
      if (k.url) doc.link(R, y0, innen, hoehe - 4, { url: k.url });

      y += hoehe;
      doc.setDrawColor.apply(doc, LINIE); doc.setLineWidth(0.3); doc.line(R, y - 2, B - R, y - 2);
    });

    /* Fuß mit Vorbehalt auf jeder Seite */
    var seiten = doc.getNumberOfPages();
    for (var s = 1; s <= seiten; s++) {
      doc.setPage(s);
      var fy = H - fussHoehe;
      doc.setDrawColor.apply(doc, GOLD); doc.setLineWidth(0.4); doc.line(R, fy, B - R, fy);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(7.2); doc.setTextColor.apply(doc, DUNKEL);
      doc.text('Hinweis – Angaben unter Vorbehalt', R, fy + 4.5);
      doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, GRAU);
      var vorbehalt = 'Alle Angaben ohne Gewähr. Termine, Kursinhalte, Menüs und Preise können sich ändern; Irrtümer vorbehalten. '
        + 'Verbindlich sind ausschließlich die Angaben im Onlineshop zum Zeitpunkt der Buchung. Dieses Programm gibt den Stand vom ' + stand + ' wieder; '
        + 'die aktuelle Verfügbarkeit findest du unter ' + shopKurz + '.';
      doc.text(doc.splitTextToSize(vorbehalt, innen - 4), R, fy + 8.2, { lineHeightFactor: 1.35 });
      doc.setTextColor.apply(doc, DUNKEL);
      doc.text('Genusshandwerk · Andreas Vick · Am Bürgerhaus 8 · 64625 Bensheim · Tel. 06251 8267893 · info@genusshandwerk-vick.com', R, H - 7);
      doc.setTextColor.apply(doc, GRAU);
      doc.text('Seite ' + s + ' von ' + seiten, B - R, H - 7, { align: 'right' });
    }

    var dateiDatum = jetzt.getFullYear() + '-' + zwei(jetzt.getMonth() + 1) + '-' + zwei(jetzt.getDate());
    return { doc: doc, name: 'Genusshandwerk-Kursprogramm-' + dateiDatum + '.pdf' };
  }

  function klick(e) {
    var btn = e.target.closest('[data-gh-pdf]');
    if (!btn || btn.disabled) return;
    var el = document.querySelector('.gh-pdf-daten');
    if (!el) return;
    var daten = JSON.parse(el.textContent);
    var label = btn.querySelector('.gh-pdf__label'), alt = label.textContent;
    btn.disabled = true; label.textContent = 'PDF wird erstellt …';
    ladeSkript(daten.jspdf)
      .then(function () { return Promise.all([ladeBild(daten.logo, true)].concat((daten.kurse || []).map(function (k) { return ladeBild(k.bild); }))); })
      .then(function (bilder) {
        var r = erstelle(daten, bilder.slice(1), bilder[0]);
        r.doc.save(r.name);
        window.ghKursprogrammLetztes = r.name;
      })
      .catch(function () { alert('Das PDF konnte gerade nicht erstellt werden. Bitte versuch es noch einmal.'); })
      .then(function () { btn.disabled = false; label.textContent = alt; });
  }
  document.addEventListener('click', klick);
  window.ghKursprogrammErstelle = erstelle;
})();
